export function calculateMinDonationAmount(
  pricePerNumber: number,
  minQuantityPerPurchase: number | null | undefined,
): number {
  const safePrice = Number.isFinite(pricePerNumber) && pricePerNumber > 0 ? pricePerNumber : 0
  const minQuantity =
    typeof minQuantityPerPurchase === 'number' && Number.isFinite(minQuantityPerPurchase)
      ? Math.max(1, Math.trunc(minQuantityPerPurchase))
      : 1

  return Math.round(safePrice * minQuantity * 100) / 100
}
